import React from "react";
import PlayerDetailPage from "../pages/PlayerDetailPage";

interface PlayerProfileModalProps {
  playerId: string;
  userRoles: string[];
  onClose: () => void;
}

const PlayerProfileModal: React.FC<PlayerProfileModalProps> = ({ playerId, userRoles, onClose }) => {
  return (
    <div className="app-dialog-backdrop" onClick={onClose}>
      <div className="app-dialog app-dialog--wide" onClick={(event) => event.stopPropagation()}>
        <div className="app-dialog__header">
          <h2>Player Profile</h2>
          <button className="app-dialog__close" onClick={onClose}>x</button>
        </div>
        <div className="app-dialog__body">
          <PlayerDetailPage userRoles={userRoles} playerIdOverride={playerId} embedded />
        </div>
      </div>
    </div>
  );
};

export default PlayerProfileModal;
